module.exports = "/_next/static/images/Hero-73e6e3a76c283d96d07947a991a9ad26.webp";